module.exports = __webpack_public_path__ + "img/zizhi6.2cfceb5d.jpg";